// extracted by mini-css-extract-plugin
export default {"container":"AutocompleteInputForm_container__DYqRk","label":"AutocompleteInputForm_label__21+5k"};